import React, { memo } from 'react';
import { validators } from 'investira.sdk';
import { Stack, Typography, Divider } from 'investira.react.components';

const pvNormalizarResposta = pResposta => {
  if (typeof pResposta !== 'string') {
    return pResposta;
  }

  try {
    const xResposta = JSON.parse(pResposta);
    return xResposta?.valor ?? xResposta;
  } catch (_pErro) {
    return pResposta;
  }
};

const pvResolverResposta = pData => {
  const xResposta = pvNormalizarResposta(pData?.resposta);
  const xDominio = Array.isArray(pData?.resposta_dominio) ? pData.resposta_dominio : [];
  const xOpcao = xDominio.find(pItem => {
    return String(pItem?.id) === String(xResposta) || String(pItem?.valor) === String(xResposta);
  });

  return xOpcao?.label || xResposta;
};

const AvaliacoesOutputRespostasAvaliacao = memo(props => {
  const { data, variant = null, nota, aliasQuestionId } = props;
  const xPlaceholderResposta = 'Resposta não informada pelo gestor.';
  const pvNormalizarTexto = pValue => {
    const xValue = String(pValue ?? '').trim();
    return validators.isEmpty(xValue) ? null : xValue;
  };
  const pvObterPrimeiroTexto = (...pValues) => pValues.map(pvNormalizarTexto).find(Boolean) || null;
  const xRespostaGestor = pvObterPrimeiroTexto(pvResolverResposta(data));
  const xJustificativa = pvObterPrimeiroTexto(data?.revisor_justificativa);
  const hasJustificativa = Boolean(xJustificativa);
  const xRespostaExibida = xRespostaGestor || xPlaceholderResposta;
  return (
    <Stack>
      <Stack>
        <Typography
          color="textPrimary"
          variant="body1"
          sx={{
            fontWeight: 600
          }}
          gutterBottom>
          {aliasQuestionId} {data.avaliacao_questao}
        </Typography>
      </Stack>
      <Stack
        sx={{
          pl: 3,
          borderLeft: '4px solid',
          borderColor: validators.isNull(nota)
            ? 'divider'
            : nota < 0
            ? 'error.main'
            : nota < 2
            ? 'warning.main'
            : 'primary.main',
          px: 2
        }}
        gap={1}>
        {!validators.isNull(nota) && (
          <>
            <Stack gap={3} direction="row" alignItems="baseline">
              <Stack direction="row" gap={2} alignItems="baseline">
                <Typography color="textPrimary" variant="h4">
                  {Number.isInteger(nota) ? `${nota}.0` : nota}
                </Typography>
              </Stack>
            </Stack>
            <Divider />
          </>
        )}

        {variant === 'justificativa' && (
          <>
            <Stack direction="row" gap={4} flexGrow={1}>
              <Stack gap={2} flexGrow={1}>
                <Stack gap={1}>
                  <Typography color="textSecondary" variant="caption">
                    Resposta do gestor
                  </Typography>
                  <Typography color="textPrimary" variant="caption">
                    {xRespostaExibida}
                  </Typography>
                </Stack>

                {hasJustificativa && (
                  <Stack gap={1}>
                    <Typography color="textSecondary" variant="caption">
                      Justificativa do avaliador
                    </Typography>
                    <Typography color="textPrimary" variant="caption">
                      {xJustificativa}
                    </Typography>
                  </Stack>
                )}
              </Stack>
            </Stack>
            <Divider />
          </>
        )}
      </Stack>
    </Stack>
  );
});
export default AvaliacoesOutputRespostasAvaliacao;
